module.exports = __webpack_public_path__ + "logo-adobe-commerce-vertical-red.5205305955d09d486d4230460c8fce3d.svg";